module.exports = __webpack_public_path__ + "images/emoji/fast_forward.cb6542f9174e832c8110.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/fast_forward.png
// module id = 5Dgx
// module chunks = 13